import { useEffect } from 'react'

interface Props {
  paymentUrl: string
  onSuccess: () => void
  onError: () => void
  onClose: () => void
}
export const GrowPaymentIframe = ({ paymentUrl, onSuccess, onError, onClose }: Props) => {
  useEffect(() => {
    // Listen for payment completion messages
    const handleMessage = (event: MessageEvent) => {
      if (event.origin === 'https://secure.meshulam.co.il' || event.origin === 'https://sandbox.meshulam.co.il') {
        switch (event.data.action) {
          case 'close':
            onClose()
            break
          case 'payment':
          case 'google_payment':
            if (event.data.status === 1) {
              // Payment successful
              onSuccess()
            }
            break
          case 'failed_to_load_page':
            onError()
            break
        }
      }
    }

    window.addEventListener('message', handleMessage)
    return () => window.removeEventListener('message', handleMessage)
  }, [onClose, onError, onSuccess])
  return <iframe src={paymentUrl} className='h-full w-full border-0' title='Payment iframe' allow='payment' />
}
